import React from "react";
import "./modal.css";
import closeBtn from "../img/close.png";
import adImg from "../img/ad-img.jpg";

const adStyle = {
  width:'100%',
  height:'100%',
  objectFit:'cover'
};

function Modal({ closeModal }) {
    return (
      <div className="modalBackground">
        <div className="modalContainer">
          <div className="titleCloseBtn">
            <button
              onClick={() => {
                closeModal(false);}}>
                    <img className="closeBtn" src={closeBtn}  alt="closeBtn"/>
            </button>
          </div>
          <div className="title">
            <h3>NFT HEROES</h3>
          </div>
          <div className="body">
            <div className="adspace-img"><img style={adStyle} src={adImg} alt="adImg" /></div>
            <p>NFT Kingdoms is in beta.<br/>Heroes - therealbryanho, sabrinamok.<br/>Boutique agency based in Singapore breaking into the NFT and crypto space.</p>
          </div>
          <div className="footer">
            <button className="btnBg"><a target="_blank" href="https://smmile.com/">SMMILE.com</a></button>
          </div>
        </div>
      </div>
    );
  }
  
  export default Modal;